module.exports = __webpack_public_path__ + "static/media/notfound.0eed6b01.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/notfound.png
// module id = 995
// module chunks = 19